<template>
  <div id="app" :class="`lang-${$i18n.locale}`">
    <!-- 根据设备类型显示不同的导航 -->
    <HeaderNavDesktop v-if="responsiveState.isDesktop" />
    <HeaderNavMobile v-else />
    <router-view />
    <!-- 根据设备类型显示不同的页脚 -->
    <FooterNav v-if="responsiveState.isDesktop" />
    <FooterNavMobile v-else />
    <!-- Cookie同意弹框 -->
    <CookieConsent />
    <!-- 字体加载状态 -->
    <!-- <FontLoadingStatus /> -->
  </div>
</template>

<script>
import HeaderNavDesktop from "./components/HeaderNavDesktop.vue";
import HeaderNavMobile from "./components/HeaderNavMobile.vue";
import FooterNav from "./components/FooterNav.vue";
import FooterNavMobile from "./components/FooterNavMobile.vue";
import CookieConsent from "./components/CookieConsent.vue";
// import FontLoadingStatus from "./components/FontLoadingStatus.vue";
import { mobileOptimizations } from './utils/responsive.js'

export default {
  name: "App",
  components: {
    HeaderNavDesktop,
    HeaderNavMobile,
    FooterNav,
    FooterNavMobile,
    CookieConsent,
    // FontLoadingStatus,
  },
  provide() {
    return {
      responsiveState: this.responsiveState
    }
  },
  data() {
    return {
      responsiveState: {
        isDesktop: window.innerWidth >= 1024
      }
    }
  },
  mounted() {
    // 应用移动端优化
    if (window.innerWidth < 1024) {
      mobileOptimizations.preventDoubleTapZoom()
      mobileOptimizations.setViewport()
      mobileOptimizations.optimizeScroll()
    }
    // 动态设置页面标题和描述
    this.updatePageMeta()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    '$i18n.locale'() {
      this.updatePageMeta()
    }
  },
  methods: {
    handleResize() {
      this.responsiveState.isDesktop = window.innerWidth >= 1024
    },
    updatePageMeta() {
      // 设置页面标题
      document.title = this.$t('fontTitle')
      
      // 设置页面描述
      const metaDesc = document.querySelector('meta[name="description"]')
      if (metaDesc) {
        metaDesc.setAttribute('content', this.$t('fontDesc'))
      }
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Alibaba PuHuiTi";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #282938;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
}

#app {
  min-height: 100vh;
}
</style>
